import { Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import 'rxjs/add/operator/filter';

@Component({
  selector: 'breadcrumbs-nav',
  template: `
  <ul class="breadcrumb">
    <li *ngFor="let breadcrumb of breadcrumbs; let last = last" [class.active]="last">
      <a [routerLink]="breadcrumb.url" *ngIf="!last"><i class="{{breadcrumb.icone}}" style="font-size: 12px;"></i> {{breadcrumb.label}}</a>
      <span *ngIf="last">{{breadcrumb.label}}</span>
    </li>
  </ul>
  `
})
export class BreadcrumbsComponent {
  breadcrumbs: Array<Object>;
  constructor(private router:Router, private route:ActivatedRoute) {}
  ngOnInit() {
    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe(event => {  // note, we don't use event
        this.breadcrumbs = [];
        let currentRoute = this.route.root,
          url = '';
        do {
          let childrenRoutes = currentRoute.children;
          currentRoute = null;
          childrenRoutes.forEach(route => {
            if(route.outlet === 'primary') {
              let routeSnapshot = route.snapshot;
              url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');
              this.breadcrumbs.push({
                label: route.snapshot.data['breadcrumb'],
                icone: route.snapshot.data['icone'],
                url:   url });
              currentRoute = route;
            }
          })
        } while(currentRoute);
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/breadcrumbs.component.ts